import React, { useEffect } from "react";

import { Button, message, Modal, Space, Table, Typography } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { cardPolicies } from "../../../../actions/cards/cards";
import {
  DeleteExpensePolicies,
  expense_policies_delete,
  expense_policies_list,
  ShowExpensePolicies,
  show_expense_policy,
} from "../../../../actions/expenses/expenses";
import AddNewIcon from "../../../../assets/icons/add_new_white.png";
import DeleteIcon from "../../../../assets/icons/delete.png";
import EditIcon from "../../../../assets/icons/edit.png";
import PageHeader from "../../../PageHeader";
import "./../styles/policy.css";
import AddExpense from "./AddExpense";
import { hasAccess } from "../../../../utils";
const { Title } = Typography;

const Expense = () => {
  const [isModalVisible, setIsModalVisible] = React.useState(false);
  const selectedRow = useSelector(
    (state) => state?.expenses?.show_policy?.data?.response,
  );
  const dispatch = useDispatch();
  const data = useSelector(
    (state) => state?.expenses?.policies?.data?.response?.expense_policies,
  );
  const total_records = useSelector(
    (state) => state?.expenses?.policies?.data?.total_records,
  );
  const deleteRecord = useSelector((state) => state?.expenses?.delete_policy);

  const handleCancel = () => {
    setIsModalVisible(false);
    dispatch({
      type: ShowExpensePolicies.RESET,
    });
  };

  const columns = [
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      render: (text, data) => {
        return (
          <div className={`render_common_style status_${data?.Status}`}>
            {text}
          </div>
        );
      },
    },
    {
      title: "Description",
      dataIndex: "description",
      key: "description",
    },
    hasAccess("policies_and_limits", "write")
      ? {
          title: "Actions",
          key: "action",
          render: (text, record) => (
            <Space key={record.id} size="middle">
              <button
              // onClick={() => showEditModal(record.id)}
              >
                <img
                  src={EditIcon}
                  alt={"logo"}
                  className="action-logo"
                  onClick={() => {
                    dispatch(
                      show_expense_policy({
                        id: record.id,
                      }),
                    );
                    setIsModalVisible(true);
                  }}
                />
              </button>
              {record.key !== "1" ? (
                <button
                // onClick={() => showDeleteModal(record.id)}
                >
                  <img
                    src={DeleteIcon}
                    alt={"logo"}
                    className="action-logo"
                    onClick={() => {
                      dispatch(
                        expense_policies_delete({
                          id: record.id,
                        }),
                      );
                    }}
                  />
                </button>
              ) : null}
            </Space>
          ),
        }
      : {},
  ];

  useEffect(() => {
    dispatch(expense_policies_list());
    dispatch(
      cardPolicies({
        type: "expense",
      }),
    );
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (deleteRecord?.data?.status) {
      dispatch(expense_policies_list());
      dispatch({
        type: DeleteExpensePolicies.RESET,
      });
    }
    // eslint-disable-next-line
  }, [deleteRecord]);
  return (
    <>
      <Modal
        title={
          <Title level={4}>
            {selectedRow?.id ? "Edit" : "Add New "} Expense Policy &nbsp;
            <span className="text-small">Enter details and submit</span>
          </Title>
        }
        visible={isModalVisible}
        onCancel={handleCancel}
        footer={[]}
        className="right-alinged-modal lg"
      >
        {isModalVisible && (
          <AddExpense handleCancel={handleCancel} selectedRow={selectedRow} />
        )}
      </Modal>

      <div className="heading-div">
        <PageHeader
          title={`Policies & Limits`}
          navigation={{
            Home: "/dashboard/",

            "Policies & Limits": null,
          }}
        />
      </div>
      <div className="">
        {hasAccess("policies_and_limits", "write") && (
          <Button
            onClick={() => setIsModalVisible(true)}
            className="mb1 addNew"
          >
            <img src={AddNewIcon} alt={"logo"} className="addNew-logo" />
            Add New Expense
          </Button>
        )}
        <Table
          rowKey="id"
          columns={columns}
          dataSource={data}
          className="settingsTable"
          pagination={{
            total: total_records,
          }}
        />
      </div>
    </>
  );
};

export default Expense;
